/** Deploy-environments the app resolves at build/runtime. */
export type AppEnvironment = 'development' | 'staging' | 'production';

const APP_ENVIRONMENTS: ReadonlySet<string> = new Set([
  'development',
  'staging',
  'production',
]);

/** Parse a raw APP_ENV-style value into a valid environment. */
export function parseAppEnvironment(value: unknown): AppEnvironment {
  if (typeof value !== 'string') return 'development';
  const normalized = value.trim().toLowerCase();
  if (APP_ENVIRONMENTS.has(normalized)) {
    return normalized as AppEnvironment;
  }
  return 'development';
}

/**
 * Current deploy environment (server). Reads the runtime APP_ENV and falls
 * back to 'development' when unset or unrecognised.
 *
 * Client-side code must NOT derive the environment from APP_ENV (it isn't
 * present in the bundle). Client components that need environment awareness
 * should resolve it from the request hostname instead (see the CCSD search
 * gate in src/features/search/data/ccsdSearchGate.ts).
 */
export function getAppEnvironment(): AppEnvironment {
  return parseAppEnvironment(process.env.APP_ENV);
}

export function isProductionEnvironment(): boolean {
  return getAppEnvironment() === 'production';
}
